import { useMemoizedContentGetter } from 'utils/contentful'
import Section from 'components/Section'
import { memo } from 'react'
import { Typography, MediaImageStandard } from '@/components/Contentful'

const BasicImageModule = memo(function BasicImageModule({ config }) {
  const { title, image, descriptiveItems } = config || {}
  return (
    <Section
      disableGutters={true}
      data-testid="grid-section"
      className="pt-12 pb-8  lg:pt-20 lg:pb-12 lg:px-0 px-"
      childContainerClassName="px-4 sm:px-8"
    >
      <div className="grid grid-cols-4 gap-x-8 gap-y-0 breakpointMd:grid-cols-6 breakpointLg:grid-cols-12 breakpointLg:gap-x-8 breakpointLg:gap-y-0 breakpointXl:grid-cols-12 breakpointXl:gap-x-8 breakpointXl:gap-y-0">
        <div className="col-span-4 breakpointMd:col-span-6 breakpointLg:col-span-12 breakpointXl:col-span-12 mb-12 breakpointMd:mb-20">
          {title && (
            <Typography
              content={title}
              variant="headingXl"
              className="font-bold md:text-[72px]! m-auto leading-[120%]! text-left pb-4"
              data-testid="pictures-grid-title"
              component="h2"
            />
          )}
        </div>

        <div className="flex col-span-4 breakpointMd:col-span-6 breakpointLg:col-span-12 breakpointXl:col-span-12 m-auto overflow-hidden w-full">
          {image && (
            <MediaImageStandard
              alt={title}
              className="md:breakpointMd:max-w-[stretch] md:h-auto pb-6 border-solid border-t-0 border-x-0 border-b border-border-primary w-full lg:w-full md:scrollbar-hide"
              content={{ url: image }}
              layout="fixed"
              width={1000}
              height={455}
              fetchPriority="high"
              preload={true}
            />
          )}
        </div>
        <div className="col-span-4 breakpointMd:col-span-6 breakpointLg:col-span-12 breakpointXl:col-span-12 m-auto overflow-hidden w-full flex gap-6 pt-6 scrollbar-hide">
          {descriptiveItems &&
            descriptiveItems.length > 0 &&
            descriptiveItems.map((item, i) => (
              <div key={i} className="flex items-center gap-1.5">
                <div
                  className="w-3 h-3 rounded-sm shrink-0"
                  style={{ backgroundColor: item.color }}
                  data-testid={`descriptive-item-color-${i}`}
                />
                <Typography
                  content={item.title}
                  variant="bodyXs"
                  className="bodyXs font-normal text-content-secondary"
                  data-testid={`descriptive-item-title-${i}`}
                  component="h4"
                />
              </div>
            ))}
        </div>
      </div>
    </Section>
  )
})

function BasicImage({ content }) {
  const { config } = useMemoizedContentGetter(content, ['config'])
  return <BasicImageModule config={config?.jsonContent || {}} />
}

export { BasicImage, BasicImageModule }
export default BasicImage
